import {Action} from '@ngrx/store';
import {Update} from '@ngrx/entity';
import {FloorMap} from '../floor-map.model';

export enum FloorMapActionTypes {
  LoadFloorMaps = '[FloorMap] Load FloorMaps',
  AddFloorMap = '[FloorMap] Add FloorMap',
  UpsertFloorMap = '[FloorMap] Upsert FloorMap',
  AddFloorMaps = '[FloorMap] Add FloorMaps',
  UpsertFloorMaps = '[FloorMap] Upsert FloorMaps',
  UpdateFloorMap = '[FloorMap] Update FloorMap',
  UpdateFloorMaps = '[FloorMap] Update FloorMaps',
  DeleteFloorMap = '[FloorMap] Delete FloorMap',
  DeleteFloorMaps = '[FloorMap] Delete FloorMaps',
  ClearFloorMaps = '[FloorMap] Clear FloorMaps',
  GetFloorMaps = '[FloorMap]Get FloorMaps',
  GetAddFloorMaps = '[FloorMap]Get Add FloorMaps',
  GetUpdateFloorMaps = '[FloorMaps]Get Update FloorMaps',
  GetDeleteFloorMaps = '[FloorMaps]Get Delete FloorMaps'
}

export class LoadFloorMaps implements Action {
  readonly type = FloorMapActionTypes.LoadFloorMaps;
  constructor(public payload: { floorMaps: FloorMap[] }) {}
}

export class AddFloorMap implements Action {
  readonly type = FloorMapActionTypes.AddFloorMap;
  constructor(public payload: { floorMap: FloorMap }) {}
}

export class UpsertFloorMap implements Action {
  readonly type = FloorMapActionTypes.UpsertFloorMap;
  constructor(public payload: { floorMap: FloorMap }) {}
}

export class AddFloorMaps implements Action {
  readonly type = FloorMapActionTypes.AddFloorMaps;
  constructor(public payload: { floorMaps: FloorMap[] }) {}
}

export class UpsertFloorMaps implements Action {
  readonly type = FloorMapActionTypes.UpsertFloorMaps;
  constructor(public payload: { floorMaps: FloorMap[] }) {}
}

export class UpdateFloorMap implements Action {
  readonly type = FloorMapActionTypes.UpdateFloorMap;
  constructor(public payload: { floorMap: Update<FloorMap> }) {}
}

export class UpdateFloorMaps implements Action {
  readonly type = FloorMapActionTypes.UpdateFloorMaps;
  constructor(public payload: { floorMaps: Update<FloorMap>[] }) {}
}

export class DeleteFloorMap implements Action {
  readonly type = FloorMapActionTypes.DeleteFloorMap;
  constructor(public payload: { id: string }) {}
}

export class DeleteFloorMaps implements Action {
  readonly type = FloorMapActionTypes.DeleteFloorMaps;
  constructor(public payload: { ids: string[] }) {}
}

export class ClearFloorMaps implements Action {
  readonly type = FloorMapActionTypes.ClearFloorMaps;
}

export class GetFloorMaps implements Action {
  readonly type = FloorMapActionTypes.GetFloorMaps;
  constructor(public payload: any = null) {}
}

export class GetAddFloorMaps implements Action {
  readonly type = FloorMapActionTypes.GetAddFloorMaps;
  constructor(public payload: { floorMap: FloorMap }) {}
}

export class GetUpdateFloorMaps implements Action {
  readonly type = FloorMapActionTypes.GetUpdateFloorMaps;
  constructor(public payload: { floorMap: FloorMap }) {}
}

export class GetDeleteFloorMaps implements Action {
  readonly type = FloorMapActionTypes.GetDeleteFloorMaps;
  constructor(public payload: { id: string }) {}
}

export type FloorMapActions =
  LoadFloorMaps
  | AddFloorMap
  | UpsertFloorMap
  | AddFloorMaps
  | UpsertFloorMaps
  | UpdateFloorMap
  | UpdateFloorMaps
  | DeleteFloorMap
  | DeleteFloorMaps
  | ClearFloorMaps
  | GetAddFloorMaps
  | GetUpdateFloorMaps
  | GetDeleteFloorMaps
  | GetFloorMaps;
